export default "__VITE_ASSET__BDrUohzt__"